export default __webpack_public_path__ + "static/media/marker-gray-sky-yellow.f00d0354.png";